import styled from 'styled-components';

import { DateRangePicker } from 'react-date-range';

import { DefaultSelect } from 'assets/styled/sheets/components/Forms';
import { inputStyleFactory } from 'components/Form/shared/inputStyleFactory';
import { colors, medias } from 'assets/styled/tokens';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

export const StyledInputWrapper = styled.div`
  width: 100%;
  position: relative;
  background: ${colors.white};
  background-color: #ffffff !important;
  //width: 332px;
  //left: -25px;
  & > svg {
    position: absolute;
    z-index: 1;
    top: 50%;
    transform: translate(0, -50%);
    left: 9px;
  }
`;

export const StyledInput = styled.input`
  ${DefaultSelect};
  ${props => inputStyleFactory(props.size)};
  position: relative;
  height: 32px;
  display: inline-block;
  cursor: pointer;
  padding-left: 24px;
  width: 100%;
  color: ${colors.gray};

  cursor: ${props => props.disabled && 'not-allowed'};

  &:active {
    pointer-events: ${props => props.disabled && 'none'};
  }
  &:required {
    border-color: ${props => props.required && colors.bittersweet};
  }
`;

export const StyledDropdownContent = styled.div`
  width: 100%;
  z-index: 2;
  position: absolute;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  border-radius: 0px 0px 3px 3px;
  display: ${props => (props.isOpen ? 'block' : 'none')};
  background-color: white;
  height: 350px;
`;

export const StyledDropdownFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px;
  background: ${colors.white};
  position: absolute;
  width: 100%;
  top: 286px;
  button {
    font-size: 12px;
    line-height: 14px;
  }
`;

export const StyledDateRangePicker = styled(DateRangePicker)`
  width: 100% !important;
  position: relative;
  z-index: 2;
  transform: scale(0.85);
  top: -26px;
  left: -21px;
  @media (min-width: ${medias.desktopSm}) {
    left: 0;
  }
  .rdrDateDisplayWrapper {
    background-color: ${colors.pampas};
  }

  .rdrMonthAndYearWrapper {
    button {
      background: ${colors.pampas};
    }
  }

  .rdrStaticRanges {
    button.rdrStaticRange {
      border-color: ${colors.whiteGray};

      .rdrStaticRangeLabel {
        padding: 10px 15px;
        :hover {
          background: ${colors.cararra};
        }
      }
    }
  }

  .rdrDefinedRangesWrapper {
    border-color: ${colors.whiteGray};
  }

  .rdrDay:hover {
    span {
      border-radius: 0 !important;
    }
  }

  .rdrDayStartPreview,
  .rdrDayEndPreview {
    border-radius: 0 !important;
  }

  .rdrDayStartOfMonth {
    .rdrDayInPreview {
      border-radius: 0 !important;
    }
  }

  .rdrDayStartOfWeek {
    .rdrInRange {
      border-top-left-radius: 0.4em !important;
      border-bottom-left-radius: 0.4em !important;
    }
    .rdrDayInPreview {
      border-radius: 0 !important;
    }
  }

  .rdrDayEndOfWeek {
    .rdrInRange {
      border-top-right-radius: 0.4em !important;
      border-bottom-right-radius: 0.4em !important;
    }

    .rdrDayInPreview {
      border-radius: 0 !important;
    }
  }

  .rdrDayEndOfWeek {
    border-top-right-radius: 0.4em;
    border-bottom-right-radius: 0.4em;
  }

  .rdrStartEdge {
    border-top-left-radius: 0.4em;
    border-bottom-left-radius: 0.4em;
  }
  .rdrEndEdge {
    border-top-right-radius: 0.4em;
    border-bottom-right-radius: 0.4em;
  }
`;
